import React, { useEffect, useState } from 'react';
import { Star } from 'lucide-react';
import { isFavorite, toggleFavorite, subscribeFavorites } from '@/lib/favorites';
import { toast } from 'sonner';

export default function FavoriteStar({ code, size = 18, className = '' }) {
  const [favored, setFavored] = useState(false);

  useEffect(() => {
    setFavored(isFavorite(code));
    return subscribeFavorites(() => setFavored(isFavorite(code)));
  }, [code]);

  if (!code) return null;

  const handle = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const next = toggleFavorite(code);
    const nowFavorite = next.includes(code.toUpperCase());
    toast.success(
      nowFavorite ? `${code.toUpperCase()} added to favorites` : `${code.toUpperCase()} removed from favorites`
    );
  };

  return (
    <button
      type="button"
      onClick={handle}
      data-testid={`favorite-star-${code}`}
      aria-label={favored ? 'Remove from favorites' : 'Add to favorites'}
      title={favored ? 'Remove from favorites' : 'Add to favorites'}
      className={`inline-flex items-center justify-center rounded-md p-1.5 transition-colors hover:bg-amber-50 ${className}`}
    >
      <Star
        size={size}
        className={
          favored
            ? 'text-amber-400 fill-amber-400'
            : 'text-slate-300 hover:text-amber-400'
        }
      />
    </button>
  );
}
